const languageLabels = [
  { code: 'uk-UA', name: 'Українська' },
  { code: 'ru-RU', name: 'Русский' },
  // Add other languages as needed
]

export default languageLabels